import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Router } from '@angular/router';
import { Location } from '@angular/common';
import Swal from 'sweetalert2';
import { GlobalStorage } from 'src/app/global/storage';
import { PresentsService } from 'src/services';
import { Order, Present } from 'src/models';
import { StepType } from 'src/types';
import { ProductType } from '@kokusai/smacere-shared/api';
import { Sorts } from 'src/app/core/utilities/sorts';
import { BundleCartService, BundleType } from '../../../../services/bundle-cart.service';

@Component({
  selector: 'app-card-present',
  templateUrl: './card-present.component.html',
  styleUrls: ['./card-present.component.scss'],
})
export class CardPresentComponent implements OnInit {
  @Input()
  From: StepType;

  @Output()
  OnBackScreenEvent: EventEmitter<any> = new EventEmitter<any>();

  private Order: Order = null;
  Presents: Present[] = [];
  selectedPresent?: Present;

  public isEdit: boolean = false;

  constructor(
    private storage: GlobalStorage,
    private presentsService: PresentsService,
    private route: Router,
    private location: Location,
    private bundleCartService: BundleCartService
  ) {}

  ngOnInit(): void {
    this.bundleCartService.checkStep(BundleType.Card, 'present');

    this.Order = this.storage.Order;
    let price: number = 0;
    if (this.Order.CardOrder) {
      price = this.Order.CardOrder.Product.price;
    }

    this.presentsService
      .gets(ProductType.Card, price, this.storage.Funeral.funeralDate)
      .subscribe((presents: Present[]) => {
        this.Presents = presents.sort((a, b) => {
          return Sorts.byJapanAlpha(a, b, 'name');
        });
      });

    if (this.Order.CardPresent) {
      this.selectedPresent = this.Order.CardPresent;
    } else {
      this.Order.CardPresent = new Present();
    }
    this.isEdit = this.bundleCartService.isEdit();
  }

  private async saveToStorage(): Promise<boolean> {
    if (!this.selectedPresent) {
      await Swal.fire({
        icon: 'warning',
        title: '弔電返礼品が未選択です',
        text: '返礼品一覧より、ご選択ください',
      });
      return false;
    }

    this.Order.CardPresent = this.selectedPresent;
    this.storage.Order = this.Order;

    return true;
  }

  async saveAction(): Promise<void> {
    if (await this.saveToStorage()) {
      await this.bundleCartService.saveCardFromStorage();
      await this.bundleCartService.goToNextStep(BundleType.Card);
    }
  }

  OSelectChange(value: Present): void {
    this.selectedPresent = value;
  }

  async addAction(): Promise<void> {
    if (await this.saveToStorage()) {
      await this.bundleCartService.saveCardFromStorage();
      await this.bundleCartService.goToAdd(BundleType.Card);
    }
  }

  back(): void {
    this.location.back();
  }
}
